import { render, staticRenderFns } from "./SettlementBuyView.vue?vue&type=template&id=a3c55212"
import script from "./SettlementBuyView.vue?vue&type=script&lang=js"
export * from "./SettlementBuyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports